import $ from 'jquery';
/* expose jQuery for modules */
window.$ = $;
window.jQuery = $;

import './WP/wp-navigation';
import './WP/skip-link-focus-fix';
import './fonts';
import MenuTrigger from './theme';


    
$(document).ready(() => {

    const menuTrigger = new MenuTrigger();
    menuTrigger.init();

});
    


